import { observer } from 'mobx-react-lite'
import { CartItemEditParticipantsButton } from './cartItemEditParticipantsButton'
import { formatPrice } from '../../utils/format-price'
import Translator from '../translator'
import React from 'react'
import { CartItemDeleteButton } from './cartItemDeleteButton'
import PropTypes from 'prop-types'
import { EventGroup } from '../../datastores/eventGroup'
import Addon from './addon'
import clx from 'classnames'
import { RootStore } from '../../datastores/rootStore'
import GA4Tracking from '../../utils/ga4-tracking'

export const CartProduct = observer(function CartProduct(props) {
  let cart = RootStore.getInstance().cart
  let eventGroup = props.eventGroup

  React.useEffect(() => {
    if (eventGroup.participants.length === 0 || eventGroup.availableAddons.length === 0) {
      return
    }

    let addonsIds = props.ga4AddonsIds
    let newAddons = []
    eventGroup.availableAddons.forEach(availableAddon => {
      if (addonsIds.includes(availableAddon.id)) {
        return
      }

      addonsIds.push(availableAddon.id)
      newAddons.push(availableAddon)
    })

    if (newAddons.length > 0) {
      // Google Analytics (GA4)
      GA4Tracking.pushEvent(
        'view_item_list',
        GA4Tracking.getItemsFromCartEventGroups(newAddons),
        {
          item_list_id: 'addons__view-list-items',
          item_list_name: 'Tilvalg',
        }
      )

      props.setGa4AddonsIds(addonsIds)
    }
  })

  return (
    <div className={clx('mtt-cart-product', { 'mtt-cart-product--error': props.hasError })}>
      <div className='mtt-cart-product__content'>
        <div className='mtt-cart-product__info'>
          <div className='mtt-cart-product__image object-fit'>
            <img src={eventGroup.featured_image} alt=""/>

          </div>
          <div className='mtt-cart-product__text'>
            <div className='mtt-cart-product__title ellipsis-two-lines'>{eventGroup.title}</div>
            <div className='mtt-cart-product__subtitle'>
              {eventGroup.subtitle}
            </div>
          </div>
        </div>
        <div className='mtt-cart-product__actions'>
          <CartItemEditParticipantsButton eventGroup={eventGroup} />
        </div>
        <div className='mtt-cart-product__price'>
          <div className='mtt-cart-product__title'>
            {formatPrice(eventGroup.price)}
          </div>
          <div className='mtt-cart-product__subtitle'>{Translator.translate('ekskl. moms', 'participant')}</div>
        </div>
      </div>
      {eventGroup.totalDiscount > 0 || (eventGroup.participants.length > 0 && eventGroup.availableAddons.length > 0) ? (
        <div className='mtt-cart-product__bottom'>
          {eventGroup.mailDiscount ? (
            <div className={clx('mtt-cart-overview__price-line', {
              'mtt-cart-overview__price-line--no-border': eventGroup.loyaltyDiscount <= 0 && eventGroup.couponDiscount <= 0 && (eventGroup.participants.length <= 0 || eventGroup.availableAddons.length <= 0)
            })}>
              <div className='mtt-cart-overview__price-line-title fw-medium'>
                <div>{Translator.translate('Maillisterabat', 'participant')}</div>
                <div className='discount'>
                  {formatPrice(eventGroup.mailDiscount*-1)}
                </div>
              </div>
            </div>
          ) : null}
          {eventGroup.loyaltyDiscount ? (
            <div className={clx('mtt-cart-overview__price-line', {
              'mtt-cart-overview__price-line--no-border': eventGroup.couponDiscount <= 0 && (eventGroup.participants.length <= 0 || eventGroup.availableAddons.length <= 0)
            })}>
              <div className='mtt-cart-overview__price-line-title fw-medium'>
                <div>{Translator.translate('Loyalitetsrabat', 'participant')}</div>
                <div className='discount'>
                  {formatPrice(eventGroup.loyaltyDiscount*-1)}
                </div>
              </div>
            </div>
          ) : null}
          {eventGroup.couponDiscountIncludingAddons ? (
            <div className={clx('mtt-cart-overview__price-line', {
              'mtt-cart-overview__price-line--no-border': eventGroup.participants.length <= 0 || eventGroup.availableAddons.length <= 0
            })}>
              <div className='mtt-cart-overview__price-line-title fw-medium'>
                <div>{cart.couponTitle ?? cart.coupon}</div>
                <div className='discount'>
                  {formatPrice(eventGroup.couponDiscountIncludingAddons*-1)}
                </div>
              </div>
            </div>
          ) : null}
          {eventGroup.participants.length > 0 && eventGroup.availableAddons.length > 0 ? (
            <React.Fragment>
              <div className='mtt-cart-product__addons-title'>
                {Translator.translate('Tilvalg', 'participant')}
              </div>
              <div className='mtt-cart-product__addons'>
                {
                  eventGroup.availableAddons.map((addon) => {
                    return (
                      <Addon eventGroup={eventGroup} addon={addon} key={addon.id} />
                    )
                  })
                }
              </div>
            </React.Fragment>
          ) : null}
        </div>
      ) : null}

      <CartItemDeleteButton
        string={Translator.translate('Fjern event fra kurven?', 'participant')}
        onConfirmed={() => {
          cart.removeModule(eventGroup.id)
        }}
      />
    </div>
  )
})
CartProduct.propTypes = {
  eventGroup: PropTypes.instanceOf(EventGroup).isRequired
}
